
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/phrasebook",
      function () {
        return require("private-next-pages/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/phrasebook/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/phrasebook"])
      });
    }
  